import axios from 'axios';
import cookieManager from '@/store/cookieManager';

export const coreServices = {
  baseUrl() { return `${process.env.VUE_APP_BASE_URL}/api`; },
  createUrl(url) {
    if (url.startsWith('http')) return url;
    return `${this.baseUrl()}${url}`;
  },
  async get(url, header, params) {
    return axios.get(this.createUrl(url), { headers: header, params: params });
  },
  async downloadBlob(url, data, header) {
    return axios.post(this.createUrl(url), data, { headers: header, responseType: 'blob' });
  },
  async downloadGetBlob(url, header) {
    return axios.get(this.createUrl(url), { headers: header, responseType: 'blob' });
  },
  async post(url, data, header) {
    return axios.post(this.createUrl(url), data, { headers: header });
  },
  async put(url, data, header) {
    return axios.put(this.createUrl(url), data, { headers: header });
  },
  async patch(url, data, header) {
    return axios.patch(this.createUrl(url), data, { headers: header });
  },
  async delete(url, header, data) {
    return axios.delete(this.createUrl(url), { headers: header, data: data });
  },
  /**
   * Get set of headers for an API request
   * @param {object} extraItemsToPush Extra key-value dictionary to add to the result
   * @return {object} Returns a dictionary object with all the needed values to add to the header of the API request,
   * such as: Token, Content-type, etc.
   */
  getRequestHeader(extraItemsToPush = null) {
    const headers = {
      Authorization: `Bearer ${cookieManager.get('Authorization')}`,
      'Content-Type': 'application/json',
    };
    if (extraItemsToPush !== null) {
      Object.assign(headers, extraItemsToPush);
    }
    return headers;
  },
};
